import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/tracking/meals/')({
  beforeLoad: () => {
    throw redirect({to: '/tracking/meals/new'});
  },
});
